import { render, staticRenderFns } from "./RoySimpleTable.vue?vue&type=template&id=6ba5d541&"
import script from "./RoySimpleTable.vue?vue&type=script&lang=js&"
export * from "./RoySimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./RoySimpleTable.vue?vue&type=style&index=0&id=6ba5d541&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports